import React, { useEffect, useState } from "react";
import styles from "./SalaryDate.module.scss";
import { useSelector, useDispatch } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";

// services
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addSalaryDate } from "../../redux/slices/registerSlice";
import { useNavigate } from "react-router-dom";
import { googleEvent_LOJ078 } from "../../lib/google-analytics";
import { googleEvent_LOJ076 } from "../../lib/google-analytics-loan-journey-events";
import { setStepperDisable } from "../../redux/slices/userSlice";
import FinboxIntroModal from "../../components/Modal/FinboxIntroModal";
import { handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function SalaryDate() {
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([]);
  const [openFinboxModal, setOpenFinboxModal] = useState({ bottom: false });
  const [finboxURL, setFinboxURL] = useState(null);

  const { salaryDate } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const { incompleteDetailsUpdate } = new ServicesAPI();
  const { handleStep } = useResponse();
  const navigate = useNavigate();

  useEffect(() => {
    googleEvent_LOJ076();
    generateDates();

    // setOpenFinboxModal({ ...openFinboxModal, bottom: true });
  }, []);

  const handleIncompleteDetailsUpdateAPI = async (data) => {
    dispatch(setStepperDisable(true));
    setLoading(true);
    const res = await incompleteDetailsUpdate(data, repeatCustomer);

    if (res && res.statusCode === 200) {
      dispatch(addSalaryDate(data.value));
      localStorage.setItem("salaryDate", data.value);

      if (repeatCustomer) {
        navigate("/confirm-details");
      } else {
        if (res.data.finboxRedirectUrl && typeof res.data.finboxRedirectUrl === "string") {
          handlehideContextualLoader();
          setOpenFinboxModal({ ...openFinboxModal, bottom: true });
          setFinboxURL(res.data.finboxRedirectUrl);
        } else {
          handleStep();
        }
      }
    }

    setLoading(false);
  };

  const generateDates = () => {
    const newDates = [];
    for (let i = 1; i <= 31; i++) {
      newDates.push(i);
    }
    setDates(newDates);
  };

  return (
    <>
      <div className={`wrapper ${styles.salaryDateStyle}`}>
        <MainHeader title="Employment Details" showProgress={true} percent={84.59} backPageName={repeatCustomer ? "/confirm-details" : ""} />
        <div className="mb-3">
          <p className="label">Date of Salary</p>
        </div>

        <div className={styles.dates}>
          {dates.map((item, index) => (
            <div
              className={`${styles.date} ${salaryDate === item ? styles.active : ""}`}
              key={index}
              onClick={() => {
                handleIncompleteDetailsUpdateAPI({
                  key: "salary_date",
                  value: item,
                });

                // Events
                googleEvent_LOJ078(item, item);
              }}
            >
              {item}
            </div>
          ))}
        </div>
      </div>

      {/* Finbox Intro Modal */}
      <FinboxIntroModal finboxURL={finboxURL} openFinboxModal={openFinboxModal} setOpenFinboxModal={setOpenFinboxModal} />
    </>
  );
}
